import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=e25c93f6&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"
import style0 from "./roles.vue?vue&type=style&index=0&id=e25c93f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25c93f6",
  null
  
)

export default component.exports